import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";
import PlayerCardField from "./Fields/PlayerCardField";
import PlayerCardImageField from "./Fields/PlayerCardImageField";

interface FooterWidgetSettingsProps {
  index: number;
}

const FooterWidgetSettings: React.FC<FooterWidgetSettingsProps> = ({ index }) => {
  return (
    <div className="playerCardWidgetOwner playerCardFooter">
      <PlayerCardField
        index={index}
        fieldName="disclaimer"
        fieldLabel="Disclaimer"
        component={TextareaAutosize}
        placeholder="Disclaimer"
        maxRows={7}
      />
      <div className="mediaContainer">
        <PlayerCardImageField index={index} fieldName="logosMedia" fieldLabel="Logos" aspect={1 / 1} allowMultiple />
      </div>
    </div>
  );
};
export default FooterWidgetSettings;
